const validatorNameKeys: { [name: string]: string } = {
  DetainedGpsDeviceValidator: "validators.translation.detainedGpsDevice",
  GpsDeviceIssueValidator: "validators.translation.gpsDeviceIssue",
  NoResponseGpsDeviceValidator: "validators.translation.noResponseGpsDevice",
  NoInvoiceValidator: "validators.translation.noInvoice",
  OptimaSyncValidator: "validators.translation.optimaSync",
  WrongAddressPosibilityValidator: "validators.translation.wrongAddressPosibility",
};

// Translates a validator type name returned by the API (t from useTranslation("admin")); unknown names are returned as they are
export const translateValidatorName = (name: string, t: (key: string) => string): string =>
  validatorNameKeys[name] !== undefined ? t(validatorNameKeys[name]) : name;

const validatorDescriptionKeys: { [name: string]: string } = {
  DetainedGpsDeviceValidator: "validators.descriptions.detainedGpsDevice",
  GpsDeviceIssueValidator: "validators.descriptions.gpsDeviceIssue",
  NoResponseGpsDeviceValidator: "validators.descriptions.noResponseGpsDevice",
  NoInvoiceValidator: "validators.descriptions.noInvoice",
  OptimaSyncValidator: "validators.descriptions.optimaSync",
  WrongAddressPosibilityValidator: "validators.descriptions.wrongAddressPosibility",
};

const validatorsWithDays = ["DetainedGpsDeviceValidator", "NoResponseGpsDeviceValidator", "NoInvoiceValidator"];

// Descriptions are built by the API in Polish with the configured number of days, e.g. "... przez ostatnie 7 dni";
// the number is taken from the API text so the translation follows the configuration. Unknown validators keep the API text.
export const translateValidatorDescription = (name: string, description: string, t: (key: string, options?: any) => string): string => {
  const key = validatorDescriptionKeys[name];
  if (key === undefined || !description) {
    return description;
  }
  const days = description.match(/\d+/);
  if (validatorsWithDays.includes(name) && !days) {
    return description;
  }
  const translated = t(key, { days: days ? days[0] : "" });
  return translated === key ? description : translated;
};
